import CloudDownloadRenderer from "./cell-renderers/cloud-download.cell-renderer";
import menuCellRenderer from "./cell-renderers/menu-cell-renderer";


class QueuedReportsService {


  static colDefs = [

    {
      headerName: '',
      cellRenderer: menuCellRenderer,
      width: 50,
      cellStyle: { border: 'none' }
    },
    { field: "reportSubscriptionId" ,width: 130},   
    { field: "reportName" },
    { field: "createdByUserLogin" ,headerName:"Created User",width: 130},
   
    { field: "statusDescription", headerName:"Status",width: 130},   
    { field: "file",  cellRenderer:CloudDownloadRenderer ,  width: 130},
    { field: "dateCreate", headerName:"Created Date",  width: 250 },
    { field: "dateStart", headerName:"Date Started",  width: 250 },
   
    { field: "dateComplete", headerName:"Date Completed",  width: 250 },
   // { field: "cancelTask" }, //temporarily commented
   // { field: "dateCancel", headerName:"Cancel Date" },  
    
    
 
  ];


};
export default QueuedReportsService;